module.exports = __webpack_public_path__ + "img/Sappho_Musei_Capitolini.215b326a.png";